export function devicesJson (language) {
  let items

  if (language === 'es') {
    items = {
      columDataTableDevices: {
        name: 'columDataTableDevices',
        label: 'editar las columnas de la tabla de dispositivos',
        value: 'columDataTableDevices',
        option: deviceDatatableJson(language)
      },
      newGroupInDevices: {
        name: 'newGroupInDevices',
        label: 'crear un grupo'
      },
      actionSendMessageInDevices: {
        name: 'actionSendMessageInDevices',
        label: 'enviar mensaje'
      },
      selectRowsDataTableInDevices: {
        name: 'selectRowsDataTableInDevices',
        label: 'seleccionar filas de la tabla de dispositivos'
      },
      removeDevicesInDevices: {
        name: 'removeDevicesInDevices',
        label: 'eliminar dispositivos'
      },
      seeDashboardInDevices: {
        name: 'seeDashboardInDevices',
        label: 'acceder al dashboard de los dispositivos'
      }
    }
  } else if (language === 'en') {
    items = {
      columDataTableDevices: {
        name: 'columDataTableDevices',
        label: 'edit the columns of the device table',
        value: 'columDataTableDevices',
        option: deviceDatatableJson(language)
      },
      newGroupInDevices: {
        name: 'newGroupInDevices',
        label: 'create a group'
      },
      actionSendMessageInDevices: {
        name: 'actionSendMessageInDevices',
        label: 'send message'
      },
      selectRowsDataTableInDevices: {
        name: 'selectRowsDataTableInDevices',
        label: 'select rows from the device table'
      },
      removeDevicesInDevices: {
        name: 'removeDevicesInDevices',
        label: 'delete devices'
      },
      seeDashboardInDevices: {
        name: 'seeDashboardInDevices',
        label: 'access the device dashboard'
      }
    }
  }

  return (items)
}

export default function deviceDatatableJson (language) {
  let items

  if (language === 'es') {
    items = [
      { sistem: 'all', field: 'so', header: 'Sistema Operativo', disabled: false },
      { sistem: 'Windows', field: 'id_processor', header: 'Id Del Procesador', disabled: false },
      { sistem: 'all', field: 'model', header: 'Modelo', disabled: false },
      { sistem: 'all', field: 'id_user', header: 'Usuario del Dispositivo', disabled: true },
      { sistem: 'all', field: 'id_rxart', header: 'Rxart Secure', disabled: false },
      { sistem: 'all', field: 'name', header: 'Nombre', disabled: false },
      { sistem: 'all', field: 'type', header: 'Tipo de equipo', disabled: true },
      { sistem: 'all', field: 'status_lock', header: 'Estado de bloqueo', disabled: true },
      { sistem: 'all', field: 'serial_number', header: 'Número de Serie', disabled: false },
      { sistem: 'all', field: 'mac', header: 'Mac Addres', disabled: false },
      { sistem: 'Android', field: 'IMEI', header: 'IMEI', disabled: false },
      { sistem: 'Android', field: 'id_device', header: 'Id Dispositivo', disabled: false },
      { sistem: 'all', field: 'identity', header: 'Identificador', disabled: true },
      { sistem: 'all', field: 'last_date', header: 'Última Conexión', disabled: false },
      { sistem: 'all', field: 'first_date', header: 'Fecha de Activación', disabled: false },
      { sistem: 'all', field: 'ip_wan', header: 'Ip Wan', disabled: false },
      { sistem: 'all', field: 'ssid', header: 'Identificador de red SSID', disabled: false },
      { sistem: 'all', field: 'gateway', header: ' IP del equipo', disabled: false },
      { sistem: 'all', field: 'establishmentCode', header: 'Código de establecimiento', disabled: true }
    ]
  } else if (language === 'en') {
    items = [
      { sistem: 'all', field: 'so', header: 'Operating System', disabled: false },
      { sistem: 'Windows', field: 'id_processor', header: 'Id Processor', disabled: false },
      { sistem: 'all', field: 'model', header: 'Model', disabled: false },
      { sistem: 'all', field: 'id_user', header: 'Device User', disabled: true },
      { sistem: 'all', field: 'id_rxart', header: 'Rxart Secure', disabled: false },
      { sistem: 'all', field: 'name', header: 'Name', disabled: false },
      { sistem: 'all', field: 'type', header: 'Type of device', disabled: true },
      { sistem: 'all', field: 'status_lock', header: 'Locking status', disabled: true },
      { sistem: 'all', field: 'serial_number', header: 'Serial number', disabled: false },
      { sistem: 'all', field: 'mac', header: 'Mac Addres', disabled: false },
      { sistem: 'Android', field: 'IMEI', header: 'IMEI', disabled: false },
      { sistem: 'Android', field: 'id_device', header: 'Id Device', disabled: false },
      { sistem: 'all', field: 'identity', header: 'Identifier', disabled: true },
      { sistem: 'all', field: 'last_date', header: 'Last connection', disabled: false },
      { sistem: 'all', field: 'first_date', header: 'Activation date', disabled: false },
      { sistem: 'all', field: 'ip_wan', header: 'IP Wan', disabled: false },
      { sistem: 'all', field: 'ssid', header: 'SSID network identifier', disabled: false },
      { sistem: 'all', field: 'gateway', header: 'IP of the device', disabled: false },
      { sistem: 'all', field: 'establishmentCode', header: 'Establishment Code', disabled: true }
    ]
  }

  return (items)
}
